module.exports = __webpack_public_path__ + "media/svg/diamond-78867a2a.svg";